import { render, staticRenderFns } from "./ForgotModal.vue?vue&type=template&id=e93be1d8&scoped=true&"
import script from "./ForgotModal.vue?vue&type=script&lang=js&"
export * from "./ForgotModal.vue?vue&type=script&lang=js&"
import style0 from "./ForgotModal.vue?vue&type=style&index=0&id=e93be1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93be1d8",
  null
  
)

export default component.exports